import { ViewportScroller } from '@angular/common';
import { Directive, ElementRef, AfterViewInit, inject } from '@angular/core';

@Directive({
    selector: '[miFocusOnTab]',
    standalone: true
})
export class FocusOnTabDirective implements AfterViewInit {
    private el = inject(ElementRef);
    private viewportScroller = inject(ViewportScroller);

    ngAfterViewInit(): void {
        // גלילה לראש הדף
        this.viewportScroller.scrollToPosition([0, 0]);
    }
}